export const POSTS = [
  {
    slug: "action-verbs-for-resume-bullets",
    title: "Start every resume bullet with a strong action verb",
    description: "Why “Responsible for” weakens your resume, and how leading with a precise action verb makes each bullet read like an achievement.",
    date: "2026-11-03",
    readMins: 3,
    sections: [
      { p: "Recruiters skim. The first word of each bullet decides whether they keep reading, so it should say what you did, not what you were assigned." },
      { h: "Swap duty phrases for verbs", p: "“Responsible for”, “Helped with” and “Worked on” describe a job description. Verbs like Led, Built, Reduced, Negotiated and Launched describe what you actually did." },
      { before: "Responsible for the weekly sales report.", after: "Rebuilt the weekly sales report, cutting prep time from 4 hours to 1." },
      { h: "Pick the most precise verb", p: "“Managed” is vague. Did you hire, schedule, coach or budget? Choose the verb that matches the real work; it also helps your bullet match the keywords in job postings." },
      { h: "Vary them", p: "Starting five bullets with “Managed” blurs them together. Mix verbs so each bullet stands on its own." },
    ],
  },
  {
    slug: "quantify-resume-bullets-with-real-numbers",
    title: "How to add real numbers to resume bullets (without making them up)",
    description: "Numbers make achievements believable. Here's how to find honest figures for your resume bullets, even when nobody gave you a dashboard.",
    date: "2026-11-03",
    readMins: 4,
    sections: [
      { p: "A number turns a claim into evidence. But an invented or inflated number can fall apart in an interview, so every figure on your resume should be one you can explain." },
      { h: "Where real numbers hide", p: "Count what you handled: tickets, patients, customers, projects, reports, people trained. Look at time saved, money saved, volume increased, errors reduced. Old emails, performance reviews and calendars are good sources." },
      { h: "Approximate honestly", p: "If you don't know an exact figure, a careful estimate is fine: “about 40 a week” or “20+”. Use ranges or “over” rather than precise-looking guesses." },
      { before: "Handled customer complaints.", after: "Resolved 40+ customer complaints a week, keeping average response time under 6 hours." },
      { h: "When there's no number", p: "Show scale or scope instead: who it was for, how often, or what it enabled. A strong bullet without a number beats a weak bullet with a fake one." },
    ],
  },
  {
    slug: "action-task-result-bullet-formula",
    title: "The action + task + result formula for resume bullets",
    description: "A simple three-part structure that turns vague job duties into clear, measurable resume bullets recruiters remember.",
    date: "2026-11-03",
    readMins: 3,
    sections: [
      { p: "Most weak bullets are missing one of three parts. Check each line of your resume against this formula." },
      { h: "1. Action", p: "A strong verb that names what you did: Built, Cut, Led, Trained." },
      { h: "2. Task", p: "What you did it to, and how: “the onboarding checklist”, “a shared ticket queue”, “vendor renewals across 4 contracts”." },
      { h: "3. Result", p: "What changed because of it, ideally measured: time saved, money saved, more output, fewer errors." },
      { before: "Worked on onboarding for new employees.", after: "Cut onboarding time from 3 weeks to 8 days by rebuilding the training checklist." },
      { h: "Order can flex", p: "Sometimes leading with the result reads better: “Saved $18K a year by renegotiating 4 vendor contracts.” All three parts still need to be there." },
    ],
  },
  {
    slug: "tailor-resume-keywords-to-job-posting",
    title: "Tailor your resume keywords to each job posting",
    description: "How to match the language of a job posting so your resume reads as relevant to recruiters and applicant tracking systems, without keyword stuffing.",
    date: "2026-11-03",
    readMins: 3,
    sections: [
      { p: "Two people with the same experience can look very different on paper depending on whether their resume uses the words the employer used." },
      { h: "Collect the posting's language", p: "Read two or three postings for the role you want. Note the skills, tools and phrases that repeat, for example “stakeholder management”, “EHR documentation” or “CI/CD”." },
      { h: "Use them where they're true", p: "Work those exact terms into bullets that genuinely describe your experience. Never add a skill you don't have." },
      { before: "Kept track of patient info in the computer system.", after: "Maintained accurate EHR documentation for 30+ patients per shift." },
      { h: "Don't stuff", p: "A list of keywords at the bottom of a resume doesn't help a human reader. Keywords work best inside real achievements." },
    ],
  },
  {
    slug: "resume-bullet-mistakes-to-avoid",
    title: "5 resume bullet mistakes that cost interviews",
    description: "Common resume bullet mistakes, from duty lists to inflated claims, and quick fixes that make each line stronger and more credible.",
    date: "2026-11-03",
    readMins: 4,
    sections: [
      { h: "1. Listing duties instead of achievements", p: "The job description already says what the role does. Your bullets should say what you did well in it." },
      { h: "2. Vague verbs", p: "“Assisted”, “Handled” and “Worked on” hide your contribution. Name the actual action." },
      { h: "3. No result", p: "Ask “so what?” after every bullet. If there's no answer, add the outcome." },
      { h: "4. Inflated or invented claims", p: "Overstated numbers and titles are easy to spot and hard to defend in an interview. Credible beats impressive." },
      { h: "5. One resume for every job", p: "A nursing manager role and a clinical educator role value different things. Re-order and re-word bullets for each target." },
      { before: "Assisted with various marketing tasks.", after: "Launched a monthly email newsletter that grew to 2,100 subscribers in 6 months." },
    ],
  },
];

export const findPost = (slug) => POSTS.find((p) => p.slug === slug);
